(() => {
document.addEventListener('click', event => {
  const button = event.target.closest('button[data-video-src]');
  if (!button) return;
  const wrapper = button.closest('[data-dc-video]');
  if (!wrapper) return;
  try {
    let src = new URL(button.dataset.videoSrc, document.baseURI);
    const host = src.hostname.toLowerCase();
    if ((host === 'www.youtube.com' || host === 'youtube.com') && src.pathname.startsWith('/embed/')) {
      src.hostname = 'www.youtube-nocookie.com';
    } else if (host === 'player.vimeo.com' && src.pathname.startsWith('/video/')) {
      // Vimeo player permitted by explicit visitor action
    } else if (host === 'www.youtube-nocookie.com' && src.pathname.startsWith('/embed/')) {
      // Privacy enhanced YouTube URL
    } else {
      button.textContent = 'Deze video is niet beschikbaar. Gebruik de bronlink.';
      button.disabled = true;
      return;
    }
    const frame = document.createElement('iframe');
    frame.src = src.toString();
    frame.title = button.dataset.videoTitle || 'Externe videoweergave';
    frame.loading = 'lazy';
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.allowFullscreen = true;
    wrapper.replaceChildren(frame);
    wrapper.classList.add('dc-arts__frame');
  } catch { button.textContent = 'Video kon niet geladen worden.'; button.disabled = true; }
});
})();